const orderType = 'orderType',
  orderTypeDelivery =  'MENU_DEL',
  orderTypePickUp = 'MENU_TAK',
  orderTypeDineIn = 'MENU_DIN',
  deliveryAddress = 'deliveryAddress',
  deliveryTime = 'deliveryTime';

const onlineOrdering = 'Online-Ordering'
const source = 'Abacus-OO'
export {
  orderType as CONSTANT_ORDER_TYPE,
  orderTypeDelivery as CONSTANT_ORDER_TYPE_DELIVERY,
  orderTypePickUp as CONSTANT_ORDER_TYPE_PICKUP,
  orderTypeDineIn as CONSTANT_ORDER_TYPE_DINEIN,
  deliveryAddress as CONSTANT_DELIVERY_ADDRESS,
  deliveryTime as CONSTANT_DELIVERY_TIME,
  onlineOrdering,
  source,
};

export const ORDER_TYPE = {
  10: 'MENU_DEL',
  2: 'MENU_DIN',
  3: 'MENU_TAK',
  5: 'MENU_TAB',
  9: 'MENU_BUZ',
  18: 'MENU_DRI',
}
